module.exports = __webpack_public_path__ + "img/sv2_1.98e1f26f.svg";